import {commonPromise} from '../../http'

import {
    DIRECT_BROADCAST_LIST,
    JOIN_CHAT_ROOM,
    FOR_BID_SEND_MSG,
    GET_USER_SIG,
    SELECT_ADMIN_ISTRATOR,
    SETUP_ADMIN_ISTRATOR,
    SELECT_USER_SILENCE,
    SUBSCRIPTION_QUERY,
    SUBSCRIPTION_INSERT,
    QUERY_CHAT_NUM
} from '../global'


export const getLiveBroadcastList = (data) => commonPromise(data, DIRECT_BROADCAST_LIST);
export const getJoinChatRoom = (data) => commonPromise(data, JOIN_CHAT_ROOM); // 加入聊天室
export const getForBidSendMsg = (data) => commonPromise(data, FOR_BID_SEND_MSG); // 禁言用户
export const getUserSig = (data) => commonPromise(data, GET_USER_SIG); // 获取用户签名
export const getSelectAdmin = (data) => commonPromise(data, SELECT_ADMIN_ISTRATOR); // 查询角色身份
export const getSetupAdmin = (data) => commonPromise(data, SETUP_ADMIN_ISTRATOR); // 设置取消管理员
export const getSelectUser = (data) => commonPromise(data, SELECT_USER_SILENCE); // 设置取消管理员
export const subQuery = (data) => commonPromise(data, SUBSCRIPTION_QUERY); // 查询当前用户是否订阅
export const subInsert = (data) => commonPromise(data, SUBSCRIPTION_INSERT, 'post'); // 添加订阅
export const chatNum = (data) => commonPromise(data, QUERY_CHAT_NUM); // 直播观看人数



// WEBPACK FOOTER //
// ./src/api/apiModules/liveBroadcast.js